import {Pipe, PipeTransform} from '@angular/core';
import {MachineAppccDto} from "../../../Models/Tasks/Appccs/Checkpoints/machine-appcc.interface";

@Pipe({
  name: 'machines',
  standalone: false
})
export class MachinesPipe implements PipeTransform {

  transform(items: MachineAppccDto[], filter: { local?: number, department?: number }): MachineAppccDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.id_local === filter.local);
    }

    if (filter.department) {
      items = items.filter((item) => item.id_departamento === filter.department);
    }

    return items;

  }

}
